import { createAction } from 'redux-act';
// helpers/constants
import * as GC from '../../constants';
//////////////////////////////////////////////////

export const visitPage = createAction(GC.VISIT_DRIVER_CARDS_PAGE_V2);
export const setPageVisited = createAction('setDriverCardsV2PageVisited');
export const applyPageDefaults = createAction('applyDriverCardsV2PageDefaults');
export const loadPageDefaultsRequest = createAction('loadDriverCardsV2PageDefaultsRequest');
export const setVisibleDays = createAction('setDriverCardsV2VisibleDays');
export const setShowTeam = createAction('setDriverCardsV2ShowTeam');
export const selectResource = createAction('selectDriverCardsV2Resource');
export const openEditSession = createAction('openDriverCardsV2EditSession');
export const assignUnassignedLoad = createAction('assignDriverCardsV2UnassignedLoad');
export const removeDraftLoad = createAction('removeDriverCardsV2DraftLoad');
export const cancelUnassignedLoadAssignment = createAction('cancelDriverCardsV2UnassignedLoadAssignment');
export const setDraftLoadRate = createAction('setDriverCardsV2DraftLoadRate');
export const editDraftLoadRate = createAction('editDriverCardsV2DraftLoadRate');
export const editDraftStop = createAction('editDriverCardsV2DraftStop');
export const editDraftStopAppointments = createAction('editDriverCardsV2DraftStopAppointments');
export const discardEditSession = createAction('discardDriverCardsV2EditSession');
export const commitTimelineEdit = createAction('commitDriverCardsV2TimelineEdit');
export const undoTimelineEdit = createAction('undoDriverCardsV2TimelineEdit');
export const redoTimelineEdit = createAction('redoDriverCardsV2TimelineEdit');
export const hydrateEditLoadEvents = createAction('hydrateDriverCardsV2EditLoadEvents');
export const refreshEditLoadRequest = createAction('refreshDriverCardsV2EditLoadRequest');
export const refreshEditLoadStart = createAction('refreshDriverCardsV2EditLoadStart');
export const refreshEditLoadSuccess = createAction('refreshDriverCardsV2EditLoadSuccess');
export const refreshEditLoadFailure = createAction('refreshDriverCardsV2EditLoadFailure');
export const routeBuilderRouteSaved = createAction('driverCardsV2RouteBuilderRouteSaved');
export const resolveEditLoadConflict = createAction('resolveDriverCardsV2EditLoadConflict');
export const updateLoadColorSuccess = createAction('updateDriverCardsV2LoadColorSuccess');
export const setResourceMode = createAction('setDriverCardsV2ResourceMode');
export const setResourceFilter = createAction('setDriverCardsV2ResourceFilter');
export const setResourceSearch = createAction('setDriverCardsV2ResourceSearch');
export const setResourceGroupBy = createAction('setDriverCardsV2ResourceGroupBy');
export const setCustomerFilter = createAction('setDriverCardsV2CustomerFilter');
export const setLoadReferenceFilter = createAction('setDriverCardsV2LoadReferenceFilter');
export const setRequestDateRange = createAction('setDriverCardsV2RequestDateRange');
export const saveEditSessionRequest = createAction('saveDriverCardsV2EditSessionRequest');
export const saveEditSessionFailure = createAction('saveDriverCardsV2EditSessionFailure');
export const loadPageDataRequest = createAction('loadDriverCardsV2PageDataRequest');
export const toggleUnassignedPanel = createAction('toggleDriverCardsV2UnassignedPanel');
export const toggleResourceGroup = createAction('toggleDriverCardsV2ResourceGroup');
export const loadResourceGroupStart = createAction('loadDriverCardsV2ResourceGroupStart');
export const loadResourceGroupSuccess = createAction('loadDriverCardsV2ResourceGroupSuccess');
export const loadResourceGroupFailure = createAction('loadDriverCardsV2ResourceGroupFailure');
export const loadResourceGroupInfoRequest = createAction('loadDriverCardsV2ResourceGroupInfoRequest');
export const loadResourceGroupInfoSuccess = createAction('loadDriverCardsV2ResourceGroupInfoSuccess');
export const loadResourceGroupInfoFailure = createAction('loadDriverCardsV2ResourceGroupInfoFailure');
export const loadAssignedResourcesRequest = createAction('loadDriverCardsV2AssignedResourcesRequest');
export const loadAssignedResourcesSuccess = createAction('loadDriverCardsV2AssignedResourcesSuccess');
export const loadAssignedResourcesFailure = createAction('loadDriverCardsV2AssignedResourcesFailure');
export const loadUnassignedLoadsRequest = createAction('loadDriverCardsV2UnassignedLoadsRequest');
export const loadUnassignedLoadsSuccess = createAction('loadDriverCardsV2UnassignedLoadsSuccess');
export const loadUnassignedLoadsFailure = createAction('loadDriverCardsV2UnassignedLoadsFailure');
